import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'
import { Accordion } from 'components/_new/ui/Accordion'
import AppStoreButton from 'components/ui/AppStoreButton/AppStoreButton'
import commonMessages from 'components/layout/Footer/FooterView/messages'

import FooterSocials from '../FooterSocials/FooterSocials'
import Section from './Section/Section'

import s from './Mobile.scss'


class FooterMobile extends Component {

  static propTypes = {
    shop: PropTypes.object,
    about: PropTypes.object,
    collectEmailFormNode: PropTypes.node,
    isAddressVisible: PropTypes.bool,
  }

  static defaultProps = {
    isAddressVisible: false,
  }

  state = {
    activeSection: null,
  }

  toggleSection = (name) => {
    const activeSection = this.state.activeSection === name ? null : name

    this.setState({
      activeSection,
    })
  }

  render() {
    const { activeSection } = this.state
    const { about, shop, collectEmailFormNode, isAddressVisible, isLandings } = this.props

    const year = new Date().getFullYear()

    const inviteLinkProps = isLandings ? {
      toOLD: links.invite,
    } : {
      to: links.invite,
    }

    const requestLinkProps = isLandings ? {
      toOLD: links.request,
    } : {
      to: links.request,
    }

    return (
      <div className={s.mobile}>
        <Accordion>
          <div className={s.sections}>
            <Section {...{ ...about, isLandings, activeSection, toggleSection: this.toggleSection }} />
            <Section {...{ ...shop, isLandings, activeSection, toggleSection: this.toggleSection }} />
          </div>
        </Accordion>
        <div className={s.container}>
          <AppStoreButton isLandings={isLandings} />
        </div>
        <div className={s.container}>
          {collectEmailFormNode}
          <FormattedMessage className={s.socialsTitle} tag="div" {...commonMessages.followUs} />
          <FooterSocials />
        </div>
        <div className={s.brandLinkContainer}>
          <Link className={s.brandLink} customColor title={commonMessages.inviteAndEarn} {...inviteLinkProps} />
          <Link className={s.brandLink} customColor title={commonMessages.requestFragrance} {...requestLinkProps} />
        </div>
        <div className={s.copyrights}>
          <FormattedMessage {...commonMessages.copyrights} values={{ year }} />
          {
            isAddressVisible && (
              <span itemScope itemType="http://schema.org/LocalBusiness">
                <span itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                  &nbsp;<span itemProp="streetAddress">10 W 33rd St Rm 1011</span>
                  &nbsp;<span itemProp="addressLocality">New York</span>,
                  &nbsp;<span itemProp="addressRegion">NY</span>
                  &nbsp;<span itemProp="postalCode">10001-3317</span>
                </span>
              </span>
            )
          }
        </div>
        <div className={s.links}>
          <Link className={s.link} customColor toOLD="/privacy" title={commonMessages.privacyPolicy} />&nbsp;·&nbsp;
          <Link className={s.link} customColor toOLD="/terms" title={commonMessages.termsAndConditions} />
        </div>
      </div>
    )
  }
}


export default FooterMobile
